module.exports = __webpack_public_path__ + "img/pic2.833b992b.jpg";